import type { IColorSchemeSeed } from './IColorSchemeSeed';
import type { IColorSchemeTokens } from './IColorSchemeTokens';

/** Число без шуму двійкових дробів (0.0024000000000000002 → 0.0024), як його записав би дизайнер. */
const num = (value: number): string => String(Number(value.toFixed(5)));
const oklch = (l: number, c: number, h: number): string => `oklch(${num(l)} ${num(c)} ${num(h)})`;

/** Токени світлої схеми — формула light() прототипу v4: білі поверхні, нейтралі з легким відтінком тону схеми. */
export function lightTokens({ hue: h, chroma: c, accent: [aL, aC, aH], overrides }: IColorSchemeSeed): IColorSchemeTokens {
  return {
    bg: oklch(0.982, c * 0.4, h), side: oklch(0.96, c * 0.7, h), surface: 'oklch(1 0 0)', surface2: oklch(0.968, c * 0.6, h),
    line: oklch(0.91, c, h), line2: oklch(0.85, c, h), ink: oklch(0.23, c, h), muted: oklch(0.5, c * 1.2, h),
    accent: oklch(aL, aC, aH), accentInk: 'oklch(0.99 0 0)', accentSoft: `oklch(0.95 ${(aC * 0.2).toFixed(3)} ${num(aH)})`,
    danger: 'oklch(0.55 0.18 27)', ...overrides,
  };
}

/** Токени темної схеми — формула dark() прототипу v4: темні поверхні 0.17–0.25, світлий текст, приглушений акцентний фон. */
export function darkTokens({ hue: h, chroma: c, accent: [aL, aC, aH], overrides }: IColorSchemeSeed): IColorSchemeTokens {
  return {
    bg: oklch(0.17, c, h), side: oklch(0.2, c, h), surface: oklch(0.215, c, h), surface2: oklch(0.25, c, h),
    line: oklch(0.3, c, h), line2: oklch(0.37, c, h), ink: oklch(0.94, c * 0.5, h), muted: oklch(0.68, c, h),
    accent: oklch(aL, aC, aH), accentInk: oklch(0.18, 0.02, aH), accentSoft: `oklch(0.3 ${(aC * 0.4).toFixed(3)} ${num(aH)})`,
    danger: 'oklch(0.68 0.17 27)', ...overrides,
  };
}
